import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import styled from "styled-components";

export const StyledAutoCreatedTag = styled.div`
    flex: none;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 18px;
    width: fit-content;
    padding: 4px 5px 4px 5px;
    border-radius: 16px;
    background-color: ${colorsPalettes.blue[100]};
`;

export const StyledAutoCreatedIcon = styled(SWReactIcons)`
    width: 10px;
    height: 10px;
    display: flex;
    align-items: center;
`;

export const StyledAutoCreatedTagSmall = styled(StyledAutoCreatedTag)`
    width: 18px;
    border-radius: 50%;
    padding: 0;

    ${StyledAutoCreatedIcon} {
        width: 11px;
        height: 11px;
    }
`;

export const StyledAutoCreatedText = styled.span`
    padding-left: 4px;
    text-transform: uppercase;
    ${setFontVariant("tag", colorsPalettes.carbon[400])};
    font-size: 10px;
    line-height: 10px;
    letter-spacing: 0.6px;
`;
